import assassination from './assassination'
import combat from './combat'
import sublety from './sublety'

const rogue = { specs: [assassination, combat, sublety] }

export default rogue
